import React from 'react';
import { Activity } from '../../types/activity';
import ActivityActions from './ActivityActions';
import ActivityStatus from './ActivityStatus';
import { useAuth } from '@/contexts/hooks/useAuth';   // adjust if your path differs

interface ActivityFooterProps {
  activity: Activity;
  isOwnProfile: boolean;
  onManageSession: (activity: Activity) => void;
  onRematch: (activity: Activity) => void;
  onDeclineRequest: () => void;
  onAccept: () => void;
  onRate?: () => void;
  isAccepting?: boolean;
  isDeclining?: boolean;
  isRating?: boolean;
}

const ActivityFooter: React.FC<ActivityFooterProps> = ({
  activity,
  isOwnProfile,
  onManageSession,
  onRematch,
  onDeclineRequest,
  onAccept,
  onRate,
  isAccepting,
  isDeclining,
  isRating
}) => {
  /* current user */
  const { user } = useAuth();

  const currentUserImage =
    user?.user_metadata?.avatar_url ??
    user?.avatar_url ??
    user?.image ??
    '';

  const currentUserName =
    user?.user_metadata?.full_name ??
    user?.full_name ??
    user?.name ??
    'you';

  /* work out the decliner for declined activities */
  const wasDeclined = activity.status === 'declined';
  const sentByYou   = activity.direction === 'sent';

  const declinerImage = wasDeclined
    ? sentByYou
      ? activity.opponent.image // opponent declined
      : currentUserImage        // you declined
    : undefined;

  const declinerName = wasDeclined
    ? sentByYou
      ? activity.opponent.name || activity.opponent.username
      : 'you'
    : undefined;

  return (
    <div className="flex items-center justify-between mt-4 pt-4 border-t border-dark-300">
      <div className="flex-1">
        <ActivityActions
          activity={activity}
          onManageSession={onManageSession}
          onRematch={onRematch}
          onDeclineRequest={onDeclineRequest}
          onAccept={onAccept}
          onRate={onRate}
          isAccepting={isAccepting}
          isDeclining={isDeclining}
          isRating={isRating}
        />
      </div>

      <div className="flex-shrink-0 ml-2">
        {isOwnProfile && (
          <ActivityStatus
            status={activity.status}
            direction={activity.direction}
            declineReason={wasDeclined ? activity.declineReason : undefined}
            declinerImage={declinerImage}
            declinerName={declinerName}
          />
        )}
      </div>
    </div>
  );
};

export default ActivityFooter;
